module.exports = __webpack_public_path__ + "images/feature/20160720_5-ed9b5cbd3871c56e7b17381d06e66a50.jpg";